module.exports = __webpack_public_path__ + "static/img/logo.bb84affe.svg";